import React, { memo } from 'react';
import styled from 'styled-components';

import MainLayout from '@views/layouts/main-layout';
import Breadcrumb from '@views/components/breadcrumb/Breadcrumb';
import { Block } from '@views/components/block';

const H1 = styled.h1`
  font-size: 17px;
  line-height: 28px;
  margin: 0 0 10px;
  font-weight: 700;
  padding: 5px 0;
  color: #444;
  border-bottom: 2px solid #ddd;
`;

const H3 = styled.h1`
  font-size: 16px;
  font-weight: 700;
`;

const ContactPage = () => {
  return (
    <MainLayout
      breadcrumb={
        <Breadcrumb
          options={[
            {
              active: true,
              name: 'Liên hệ',
            },
          ]}
        />
      }
    >
      <Block isSection className="p-2 p-md-4">
        <H1>Giới thiệu về Văn Phòng Phẩm Sơn Thủy</H1>
        <p>
          Văn Phòng Phẩm Sơn Thủy là đơn vị chuyên cung cấp văn phòng phẩm như
          giấy in, bút viết, fule hồ sơ, băng keo,.. với chất lượng phục vụ tốt
          nhất, giao hàng nhanh nhất tại TP. HCM. Qúy khách hàng có thể hoàn
          toàn hài lòng về chúng tôi.
        </p>

        <p>
          Quý khách có nhu cầu liên lạc, trao đổi hoặc đóng góp ý kiến, vui lòng
          tham khảo các thông tin sau:
        </p>
        <ul>
          <li>Liên lạc qua điện thoại/zalo: 0707 467 697 </li>
          <li>
            Liên lạc qua email:{' '}
            <a href="mailto:vanphongphamsonthuy@gmail.com">
              vanphongphamsonthuy@gmail.com
            </a>
          </li>
          <li>
            Fanpage:{' '}
            <a href="https://www.facebook.com/vanphongphamsonthuy">
              https://www.facebook.com/vanphongphamsonthuy
            </a>
          </li>
          <li>Trụ sở: 462/1 Đường Lũy Bán Bích, Hòa Thạnh, Tân Phú, TP. HCM</li>
        </ul>

        <H3>Thông tin về công ty</H3>
        <ul>
          <li>CÔNG TY TNHH SX TM DV VĂN PHÒNG PHẨM SƠN THỦY</li>
          <li>
            Trụ sở: Tầng 12 (1206), Citilight Tower, Số 45 Võ Thị Sáu, Phường Đa
            Kao, Quận 1, Thành phố Hồ Chí Minh
          </li>
          <li>
            Địa chỉ kho: 462/1 Đường Lũy Bán Bích, Hòa Thạnh, Tân Phú, TP. HCM (Vui lòng
            gọi trước)
          </li>
          <li>Giấy phép kinh doanh: cập nhật theo hình đính kèm</li>
        </ul>
        {/* <img
          src="/assets/gpkd.jpg"
          alt="Giấy phép kinh doanh"
          className="m-4 img-fluid"
          style={{ margin: 'auto' }}
        /> */}
        <H3>Văn phòng Sơn Thủy</H3>
        <div style={{ display: 'block', textAlign: 'center' }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15679.033253238804!2d106.6475149!3d10.7531009!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f9f42ccb353%3A0xb02971bc524884af!2zQ8OUTkcgVFkgVE5ISCBUTSBEViBWxIJOIFBIw5JORyBQSOG6qE0gU8agTiBUSOG7plk!5e0!3m2!1sen!2s!4v1658369228547!5m2!1sen!2s"
            width="600"
            height="450"
            style={{ border: 0, maxWidth: '100%' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          {/* <iframe
            src="//www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.718276886515!2d106.64738821467115!3d10.756181992335309!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752e8ec84ea6e7%3A0x8f1ebeef090ea3d2!2sStationery%20FAST!5e0!3m2!1sen!2s!4v1625927529855!5m2!1sen!2s"
            width="600"
            height="450"
            style={{ border: 0, maxWidth: '100%' }}
            allowFullScreen
            loading="lazy"
          /> */}
        </div>
      </Block>
    </MainLayout>
  );
};

const Wrapper = memo(ContactPage);
Wrapper.displayName = 'ContactPage';

export default Wrapper;
